<template>
  <div class="grow">
    <div v-if="booking">
      <HandoverClientDataForm
        :booking="booking"
        :read-only-contact="readOnlyContact"
        :contact-email-optional="isCounterHandover"
        :waiting-for-customer="waitingForCustomer"
        @on-submit="handleSubmit"
      />
    </div>
  </div>
</template>

<script lang="ts" setup>
import { computed, watch } from 'vue';
import { useBooking } from '@/queries/use-bookings';
import { useRoute } from 'vue-router';
import HandoverClientDataForm from './HandoverClientDataForm.vue';
import { useProcessNavigation, useProcessSessionContext } from '@/hooks/use-process-step-tracking';

const route = useRoute();
const { goToNext } = useProcessNavigation();
const { session, isCounterHandover } = useProcessSessionContext();

const { data: booking, refetch: refetchBooking } = useBooking(route.params.id as string);

const readOnlyContact = computed(() => isCounterHandover.value);

const waitingForCustomer = computed(
  () => isCounterHandover.value && !session.value?.gates?.customerContactConfirmed,
);

watch(
  () => session.value?.gates?.customerContactConfirmed,
  (confirmed) => {
    if (confirmed) {
      void refetchBooking();
    }
  },
);

const handleSubmit = () => {
  if (waitingForCustomer.value) return;
  goToNext();
};
</script>
